import { cn } from "@/lib/utils";

type LogoProps = {
  /** `hero` : plus grand, centré (ex. écran de connexion). */
  size?: "default" | "hero";
  className?: string;
};

/**
 * Logo Pointo — blanc sur fond #051941 (fichier final) + libellé.
 */
export const Logo = ({ size = "default", className }: LogoProps) => {
  if (size === "hero") {
    return (
      <div
        className={cn(
          "flex flex-row flex-wrap items-center justify-center gap-3 sm:gap-4",
          className
        )}
      >
        <img
          src="/pointo-logo-white-on-blue.png"
          alt=""
          className="h-16 w-16 shrink-0 rounded-2xl object-cover shadow-lg sm:h-[4.5rem] sm:w-[4.5rem]"
        />
        <span className="font-display text-3xl font-normal leading-tight text-gray-900 sm:text-4xl">
          Pointo
        </span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-row items-center gap-2",
        className
      )}
    >
      <img
        src="/pointo-logo-white-on-blue.png"
        alt=""
        className="h-9 w-9 shrink-0 rounded-xl object-cover shadow-sm"
      />
      <span className="font-display text-xl font-normal leading-tight text-gray-900 sm:text-2xl">
        Pointo
      </span>
    </div>
  );
};
